import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'edportal-public-layout',
  templateUrl: './public-layout.component.html',
  styles: ``,
})
export class PublicLayoutComponent {}
